import {useEffect, useState} from "react";
import LoadingComponent from "../Loading/LoadingComponent";
import {baseApi} from "../../api/axios";
import {toast} from "react-toastify";
import DepartmentItem from "./DepartmentItem";
import {useParams} from "react-router-dom";

export default function DepartmentSectionComponent() {

    const [loading, setLoading] = useState(false)
    const department_id=useParams().id;
    const [categories, setCategories] = useState([])
    const [categoriesFilter, setCategoriesFilter] = useState([])
    const getCategories = async () => {
        setLoading(true)
        try {
            const response = await baseApi(`/categories/${department_id}`)
            setCategories(response.data?.categories)
            setCategoriesFilter(response.data?.categories)
        } catch (e) {
            toast.dark(e?.response?.data?.msg)
        }
        setLoading(false)
        // const response=await
    }
const filterCategories=(text)=>{
        if(text===''){
            setCategoriesFilter(categories)
        }
        setCategoriesFilter(categories.filter(item=>item.name.includes(text)))
}
    useEffect(() => {
        getCategories()
    }, [])
    if (loading) {
        return (
            <div className={'container mt-3'}>
                <div className="row justify-content-center">
                    <div className={'col-12 text-center'}>
                        <LoadingComponent/>
                    </div>
                </div>

            </div>
        )
    }
    else if (!loading && categories.length === 0) {
        return (
            <div className={'container mt-3'}>
                <div className="row justify-content-center">
                    <div className={'col-6 text-center'}>
                        <p className={'text-white bg-primary rounded py-2 fs-5 box-shadow'}>القسم غير متوفر حاليا </p>
                    </div>
                </div>

            </div>
        )
    }
    else {
        return (
            <div className={'container mt-3'}>
                <div className="row justify-content-center align-items-center">
                    <div className={'col-12'}>
                        <div className={'row justify-content-center'}>
                            <div className={'col-md-6'}>
                                <input type="text" className={'w-100 mb-4 rounded px-1'} placeholder={'ابحث عن منتج'} onChange={(e)=>filterCategories(e.target.value)}/>
                            </div>
                        </div>
                    </div>
                          {categoriesFilter.map((item)=>{
                              return <DepartmentItem key={item.id} item={item}/>
                          })}
                </div>

            </div>
        )
    }
}